import { SecurityRuleFactory, createSimpleClaimRule } from "../auth-rules";

export type IsUserClaimType = string | string[];
export type IsUserClaimArgs = {};

export const ruleIsUser: SecurityRuleFactory<IsUserClaimType, IsUserClaimArgs> =
  createSimpleClaimRule<IsUserClaimType, IsUserClaimArgs>("user");

